var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { CreateAccountUserCommand } from '../../../../commands/accounts/create.account.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { AccountUsersModalData } from './account.users.modal.provider';
var AccountUsersModalComponent = /** @class */ (function (_super) {
    __extends(AccountUsersModalComponent, _super);
    function AccountUsersModalComponent(fb, alertify, modalService, accountApiService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.accountApiService = accountApiService;
        _this.dialogRef = dialogRef;
        _this.createAccountUserCommand = new CreateAccountUserCommand('', '', '');
        _this.hubName = data.hubName;
        _this.createAccountUserCommand.hubName = _this.hubName;
        return _this;
    }
    AccountUsersModalComponent.prototype.ngOnInit = function () {
        this.createAccountFormGroup = this.fb.group({
            'userName': [null, [Validators.required]],
            'password': [null, [Validators.required]]
        });
        this.fetchAccountUsers();
    };
    AccountUsersModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    AccountUsersModalComponent.prototype.createUser = function (event) {
        var _this = this;
        this.accountApiService.createAccountUsers(this.hubName, this.createAccountUserCommand).finally(event.complete).subscribe(function (x) {
            if (x && x.success) {
                _this.alertify.successfully('User created');
                _this.fetchAccountUsers();
            }
            if (x && !x.success) {
                _this.alertify.warning(x.msg);
            }
        });
    };
    AccountUsersModalComponent.prototype.deleteUser = function (user) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService.deleteAccountUser(_this.hubName, user.userName)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.alertify.successfully('User deleted');
                    _this.fetchAccountUsers();
                });
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this user?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    AccountUsersModalComponent.prototype.fetchAccountUsers = function () {
        var _this = this;
        this.accountApiService.getAccountUsers(this.hubName)
            .subscribe(function (accounts) {
            accounts.forEach(function (x) { return x.createLocalString = new Date(x.created).toLocaleString(); });
            _this.accountUsers = accounts;
        });
    };
    return AccountUsersModalComponent;
}(BaseComponent));
export { AccountUsersModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/account.users/account.users.modal.component.ts.pre-build-optimizer.js